export const signupErrorMsgMapper = {
	'An account with the given email already exists.': 'Notandi með þetta netfang er nú þegar til',
}
